module.exports = __webpack_public_path__ + "img/order-active.e8855069.svg";